export function formatViews(views: number): string {
  if (views >= 100000000) {
    return `${(views / 100000000).toFixed(1)} 亿`;
  }
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function formatDate(date: string): string {
  const parts = date.split("-");
  if (parts.length < 3) return date;
  return `${parts[0]}-${parts[1]}-${parts[2]}`;
}

export function yearOf(date: string): string {
  return date.split("-")[0] || "";
}